import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation('home');

  const platforms = [
    {
      name: 'CSSBuy Spreadsheet',
      update: t('comparison_daily'),
      quality: t('comparison_high'),
      trust: t('comparison_high'),
      seo: t('comparison_very_high'),
      highlight: true,
    },
    {
      name: 'Pandabuy',
      update: t('comparison_weekly'),
      quality: t('comparison_high'),
      trust: t('comparison_medium'),
      seo: t('comparison_high_volume'),
      highlight: false,
    },
    {
      name: 'Sugargoo',
      update: t('comparison_weekly'),
      quality: t('comparison_medium'),
      trust: t('comparison_medium'),
      seo: t('comparison_medium_volume'),
      highlight: false,
    },
  ];

  return (
    <section className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {t('comparison_title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('comparison_subtitle')}
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-secondary-200">
                <th className="text-left py-4 px-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  {t('comparison_col_platform')}
                </th>
                <th className="text-center py-4 px-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  {t('comparison_col_update')}
                </th>
                <th className="text-center py-4 px-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  {t('comparison_col_quality')}
                </th>
                <th className="text-center py-4 px-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  {t('comparison_col_trust')}
                </th>
                <th className="text-center py-4 px-4 text-xs md:text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  {t('comparison_col_seo')}
                </th>
              </tr>
            </thead>
            <tbody>
              {platforms.map((p) => (
                <tr
                  key={p.name}
                  className={`border-b border-secondary-100 transition-colors ${
                    p.highlight ? 'bg-primary-50/50' : 'hover:bg-background-100'
                  }`}
                >
                  <td className="py-4 px-4">
                    <span
                      className={`text-sm font-semibold whitespace-nowrap ${
                        p.highlight ? 'text-primary-700' : 'text-foreground-800'
                      }`}
                    >
                      {p.name}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span
                      className={`inline-flex items-center gap-1 text-xs md:text-sm whitespace-nowrap ${
                        p.highlight ? 'text-primary-600 font-medium' : 'text-foreground-600'
                      }`}
                    >
                      {p.update === t('comparison_daily') && (
                        <i className="ri-fire-line text-accent-500"></i>
                      )}
                      {p.update}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                      {p.quality}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                      {p.trust}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span
                      className={`text-xs md:text-sm font-medium whitespace-nowrap ${
                        p.highlight ? 'text-primary-600' : 'text-foreground-600'
                      }`}
                    >
                      {p.seo}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}